import React from 'react';
import { ProgressBar } from '../shared/ProgressBar';

export interface SaveSectionProps {
  onSave: () => void;
  disabled?: boolean;
  progress?: number; // 0..100
  className?: string;
  children?: React.ReactNode;
}

export const SaveSection: React.FC<SaveSectionProps> = ({
  onSave,
  disabled,
  progress,
  className,
  children,
}) => {
  return (
    <div className={className}>
      {typeof progress === 'number' ? (
        <ProgressBar
          value={progress}
          className="mb-3"
          trackClassName="w-full h-2 bg-navy-600 rounded-full overflow-hidden"
          indicatorClassName="h-full bg-yellow-400 transition-all duration-300"
        />
      ) : null}

      {children}

      <button
        type="button"
        onClick={onSave}
        disabled={disabled}
        className={`w-full px-3 py-1.5 text-xs rounded ${
          disabled
            ? 'bg-yellow-400/60 cursor-not-allowed text-navy-900'
            : 'bg-yellow-400 hover:bg-yellow-500 text-navy-900'
        }`}
      >
        Salvar
      </button>
    </div>
  );
};